import WrapText from "./WrapText";

export * from "./ArrowBigDown";
export * from "./ArrowBigDownDash";
export * from "./ArrowBigLeft";
export * from "./ArrowBigLeftDash";
export * from "./ArrowBigRight";
export * from "./ArrowBigRightDash";
export * from "./ArrowBigUp";
export * from "./ArrowBigUpDash";
export * from "./ArrowDown";
export * from "./ArrowDown01";
export * from "./ArrowDown10";
export * from "./ArrowDownAZ";
export * from "./ArrowDownFromLine";
export * from "./ArrowDownLeft";
export * from "./ArrowDownNarrowWide";
export * from "./ArrowDownRight";
export * from "./ArrowDownToDot";
export * from "./ArrowDownToLine";
export * from "./ArrowDownUp";
export * from "./ArrowDownWideNarrow";
export * from "./ArrowDownZA";
export * from "./ArrowLeft";
export * from "./ArrowLeftFromLine";
export * from "./ArrowLeftRight";
export * from "./ArrowLeftToLine";
export * from "./ArrowRight";
export * from "./ArrowRightFromLine";
export * from "./ArrowRightLeft";
export * from "./ArrowRightToLine";
export * from "./ArrowsUpFromLine";
export * from "./ArrowUp";
export * from "./ArrowUp01";
export * from "./ArrowUp10";
export * from "./ArrowUpAZ";
export * from "./ArrowUpDown";
export * from "./ArrowUpFromDot";
export * from "./ArrowUpFromLine";
export * from "./ArrowUpLeft";
export * from "./ArrowUpNarrowWide";
export * from "./ArrowUpRight";
export * from "./ArrowUpToLine";
export * from "./ArrowUpWideNarrow";
export * from "./ArrowUpZA";
export * from "./ChevronDown";
export * from "./ChevronFirst";
export * from "./ChevronLast";
export * from "./ChevronLeft";
export * from "./ChevronRight";
export * from "./ChevronsDown";
export * from "./ChevronsDownUp";
export * from "./ChevronsLeft";
export * from "./ChevronsLeftRight";
export * from "./ChevronsRight";
export * from "./ChevronsRightLeft";
export * from "./ChevronsUp";
export * from "./ChevronsUpDown";
export * from "./ChevronUp";
export * from "./CircleArrowDown";
export * from "./CircleArrowLeft";
export * from "./CircleArrowOutDownLeft";
export * from "./CircleArrowOutDownRight";
export * from "./CircleArrowOutUpLeft";
export * from "./CircleArrowOutUpRight";
export * from "./CircleArrowRight";
export * from "./CircleArrowUp";
export * from "./CircleChevronDown";
export * from "./CircleChevronLeft";
export * from "./CircleChevronRight";
export * from "./CircleChevronUp";
export * from "./CircleFadingArrowUp";
export * from "./ClipboardCopy";
export * from "./ClipboardPaste";
export * from "./CloudDownload";
export * from "./CloudUpload";
export * from "./CornerDownLeft";
export * from "./CornerDownRight";
export * from "./CornerLeftDown";
export * from "./CornerLeftUp";
export * from "./CornerRightDown";
export * from "./CornerRightUp";
export * from "./CornerUpLeft";
export * from "./CornerUpRight";
export * from "./DatabaseBackup";
export * from "./Delete";
export * from "./Download";
export * from "./ExternalLink";
export * from "./FastForward";
export * from "./FileDown";
export * from "./FileInput";
export * from "./FileOutput";
export * from "./FileUp";
export * from "./FolderDown";
export * from "./FolderInput";
export * from "./FolderOutput";
export * from "./FolderSync";
export * from "./FolderUp";
export * from "./FoldHorizontal";
export * from "./FoldVertical";
export * from "./GitCompare";
export * from "./GitCompareArrows";
export * from "./GitPullRequest";
export * from "./GitPullRequestArrow";
export * from "./GitPullRequestCreate";
export * from "./GitPullRequestCreateArrow";
export * from "./HardDriveDownload";
export * from "./HardDriveUpload";
export * from "./History";
export * from "./Import";
export * from "./IterationCcw";
export * from "./IterationCw";
export * from "./LassoSelect";
export * from "./Maximize2";
export * from "./Merge";
export * from "./Milestone";
export * from "./Minimize2";
export * from "./MousePointer";
export * from "./MousePointer2";
export * from "./MousePointerBan";
export * from "./MousePointerClick";
export * from "./Move";
export * from "./MoveDiagonal";
export * from "./MoveDiagonal2";
export * from "./MoveDown";
export * from "./MoveDownLeft";
export * from "./MoveDownRight";
export * from "./MoveHorizontal";
export * from "./MoveLeft";
export * from "./MoveRight";
export * from "./MoveUp";
export * from "./MoveUpLeft";
export * from "./MoveUpRight";
export * from "./MoveVertical";
export * from "./PanelBottomClose";
export * from "./PanelBottomOpen";
export * from "./PanelLeftOpen";
export * from "./PanelLeftClose";
export * from "./PanelRightClose";
export * from "./PanelRightOpen";
export * from "./PanelTopClose";
export * from "./PanelTopOpen";
export * from "./PhoneForwarded";
export * from "./PhoneIncoming";
export * from "./PhoneOutgoing";
export * from "./Play";
export * from "./Redo";
export * from "./Redo2";
export * from "./RedoDot";
export * from "./RefreshCcw";
export * from "./RefreshCcwDot";
export * from "./RefreshCw";
export * from "./RefreshCwOff";
export * from "./Repeat";
export * from "./Repeat2";
export * from "./Rewind";
export * from "./RotateCcw";
export * from "./RotateCcwSquare";
export * from "./RotateCw";
export * from "./RotateCwSquare";
export * from "./SeparatorHorizontal";
export * from "./SeparatorVertical";
export * from "./Shrink";
export * from "./Shuffle";
export * from "./Signpost";
export * from "./SignpostBig";
export * from "./SkipBack";
export * from "./SkipForward";
export * from "./Split";
export * from "./SquareArrowDown";
export * from "./SquareArrowDownLeft";
export * from "./SquareArrowDownRight";
export * from "./SquareArrowLeft";
export * from "./SquareArrowOutDownLeft";
export * from "./SquareArrowOutDownRight";
export * from "./SquareArrowOutUpLeft";
export * from "./SquareArrowOutUpRight";
export * from "./SquareArrowRight";
export * from "./SquareArrowUp";
export * from "./SquareArrowUpLeft";
export * from "./SquareArrowUpRight";
export * from "./SquareChevronDown";
export * from "./SquareChevronLeft";
export * from "./SquareChevronRight";
export * from "./SquareChevronUp";
export * from "./SquareDashedMousePointer";
export * from "./SquareMousePointer";
export * from "./SquarePlay";
export * from "./StepBack";
export * from "./StepForward";
export * from "./Sunrise";
export * from "./Sunset";
export * from "./Undo";
export * from "./Undo2";
export * from "./UndoDot";
export * from "./UnfoldHorizontal";
export * from "./UnfoldVertical";
export * from "./Upload";
export * from "./WrapText";

export const Arrows = {
  WrapText,
};
